'use strict';

DoohApps
.factory('RepeatData', ['DoohHelper', function (DoohHelper) {
    var d,
        nextday,
        hour,
        minutes,
        timeString;

    const REPEAT_END_ON = '3';

    var repeatOptions = {
        REPEAT_DAYS: { value: '2', name: 'Daily', nominativeName: 'Days' },
        REPEAT_WEEKS: { value: '1', name: 'Weekly', nominativeName: 'Weeks' }
    }

    var repeat = {};
    repeat.data = {};
    
    repeat.clear = resetValues;
    repeat.clear();

    return {
        repeat: repeat,
        repeatOptions: repeatOptions
    };

    function resetValues() {
        d = new Date();
        nextday = DoohHelper.momentToDate(moment(d).add(1, 'days'));
        hour = d.getHours();
        minutes = d.getMinutes();
        timeString = `${hour > 9
            ? `${hour}`
            : `0${hour}`}:${((5 * Math.ceil(minutes / 5)) > 9)
                ? `${5 * Math.ceil(minutes / 5)}`
                : `0${5 * Math.ceil(minutes / 5)}`}`;
        
        repeat.data.Radio = REPEAT_END_ON;
        repeat.data.StartDate = d;
        repeat.data.EndDate = d;
        repeat.data.RepeatEndDate = nextday;
        repeat.data.RepeatEndTime = '';
        repeat.data.TimeRepeatStartTime = ''
        repeat.data.StartTime = timeString;
        repeat.data.EndTime = timeString;
        repeat.data.Repeats = repeatOptions.REPEAT_DAYS.value;
        repeat.data.StrRepeats = repeatOptions.REPEAT_DAYS.name;
        repeat.data.RepeatEvery = 1;//repeat every 2nd or 3rd and so on..
        repeat.data.EndsOn = true;
        repeat.data.EndsOnDate = true;
        repeat.data.NeverEnds = false;
        repeat.data.EndAfter = false;
        repeat.data.EndAfterCount = 2;
        repeat.data.Saturday = (d.getDay() == 0) ? true : false;
        repeat.data.Monday = (d.getDay() == 1) ? true : false;
        repeat.data.Tuesday = (d.getDay() == 2) ? true : false;
        repeat.data.Wednesday = (d.getDay() == 3) ? true : false;
        repeat.data.Thursday = (d.getDay() == 4) ? true : false;
        repeat.data.Friday = (d.getDay() == 5) ? true : false;
        repeat.data.Sunday = (d.getDay() == 6) ? true : false;
        repeat.data.IsAllDay = false;
        repeat.data.IsRecurrence = false;
        repeat.data.Saved = false;
        repeat.data.RepeatTime = 60;//minutes
        repeat.data.WeekdayRepeat = false;
        repeat.data.RepeatPeriod = true;
        repeat.data.TimeRepeat = false;
        repeat.data.EndAtTime = false;
        repeat.data.Summary = '';
        repeat.data.StartDateRepeat = null;
    }

}])
